<template>
    <div>
        <!-- Password dialog -->
        <v-dialog persistent width="500" v-model="password_dialog.display">
            <v-card>
                <v-toolbar dense color="primary" dark>
                    <v-row align="center" dark>
                        <v-col cols="10" align="left">
                            <v-toolbar-title>Autenticazione richiesta</v-toolbar-title>
                        </v-col>
                        <v-col cols="2" align="right">
                            <v-btn small light @click="password_dialog.display = false">
                                <v-icon color="error">mdi-close</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-toolbar>
                <v-container>
                    <v-card-text>
                        <v-row>
                            <v-col>
                                <v-text-field type="password" label="Password" v-model="password_dialog.input" @keydown.enter="getKeyDetail" />
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-container>
                <v-card-actions>
                    <v-spacer />
                    <v-btn text color="primary" @click="getKeyDetail">conferma</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Token dialog -->
        <v-dialog persistent v-model="token_dialog.display" width="500" :retain-focus="false">
            <v-card>
                <v-toolbar dense color="primary" dark>
                    <v-row align="center" dark>
                        <v-col cols="5" align="left">
                            <v-toolbar-title>Token Installer Box</v-toolbar-title>
                        </v-col>
                        <v-col cols="2" align="center">
                            <v-btn small light @click="getSettingsFile">
                                <v-icon color="success">mdi-content-copy</v-icon>
                            </v-btn>
                        </v-col>
                        <v-col cols="5" align="right">
                            <v-btn small light @click="closeTokenDialog">
                                <v-icon color="error">mdi-close</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-toolbar>
                <v-container>
                    <v-row align="center" justify="center">
                        <v-col cols="6">
                            <v-progress-circular :value="token_dialog.progress" width="10" color="orange" size="120" rotate="180"/>
                            <p style="margin-top:5px"><strong>{{ Math.round(token_dialog.seconds_left) }} secondi rimanenti</strong></p>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
export default {
    name: 'DialogTokenAnagraficaQuickConnext',
    data(){
        return{
            NETWORK : null,
            password_dialog : {
                device_id : null,
                display: false,
                input : null
            },
            token_dialog: {
                display: false,
                progress: 0,
                seconds_left:0,
                template : new Object(),
                timer_handle : null                
            }
        }
    },
    mounted(){
        this.NETWORK = this.$store.state.Network;
    },
    methods : {
        closeTokenDialog(){
            clearInterval(this.token_dialog.timer_handle);
            this.token_dialog.timer_handle = null;
            this.token_dialog.display = false;
        },
        copyTokenToClipboard(){
            const input = document.createElement('input');
            document.body.appendChild(input);
            input.value = this.token_dialog.template.token;
            input.select();
            document.execCommand('copy'); 
            document.body.removeChild(input);
        },
        promptPassword(item) {
            Object.assign(this.password_dialog, { 
                device_id: item.device_id, 
                display : true,
                input : null
            });
        },
        getKeyDetail() {
            this.password_dialog.display = false;
            const that = this;
            const request = {
                controller: 'quickconnext',
                endpoint : 'connext',
                response: { parse: false },
                body: {
                    action: 'getinstallertoken',
                    token: localStorage.user_token,
                    device_id: this.password_dialog.device_id,
                    password: this.password_dialog.input,
                },
                method: 'POST',
                on: {
                    load: function (response) {
                        response = JSON.parse(response);
                        Object.assign(that.token_dialog.template, response);

                        const start_time = Date.parse(response.start_time);
                        const duration = Number(response.duration);
                        const progess_update = function(){
                            const seconds_left = duration -((new Date() - start_time)/1000);
                            that.token_dialog.seconds_left = seconds_left;
                            that.token_dialog.progress = ((seconds_left)/duration)*100;
                            if(seconds_left < 0){
                                that.closeTokenDialog();
                            }
                        }
                        progess_update();
                        that.token_dialog.timer_handle = setInterval(progess_update, 1000);
                        that.token_dialog.display = true;
                    },
                    error: function (response) {
                        response = response.target;
                        that.$emit('error', response.responseText);
                    },
                },
            };
            this.NETWORK.AjaxRequest(request);
        },
        getSettingsFile(){
            const link = document.createElement('a');
            link.setAttribute('download', 'settings.cnx');
            link.href = this.NETWORK._baseURL + 'quickconnext/get?t=' + this.token_dialog.template.token;
            link.click();
        }
    }
}
</script>